// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"fcffce4f","467":"c1f9acc9","667":"c94b959c","748":"2f053f0e","781":"36a765aa","783":"b434dfc1"}[chunkId] + ".chunk.js";
};